import React from "react";
import styled from "styled-components";

export default function FullButton({ title, action, border }) {
  return (
    <Wrapper
      className="animate pointer radius8"
      onClick={action ? () => action() : null}
      border={border}
    >
      {title}
    </Wrapper>
  );
}

const Wrapper = styled.button`
  border: 1px solid ${(props) => (props.border ? "#209FA0" : "#209FA0")};
  background-color: ${(props) => (props.border ? "transparent" : "#209FA0")};
  width: 100%;
  padding: 15px;
  outline: none;
  color: ${(props) => (props.border ? "#707070" : "#fff")};
  :hover {
    background-color: ${(props) => (props.border ? "transparent" : "#FADB73")};
    border: 1px solid #FADB73;
    color: ${(props) => (props.border ? "#7620ff" : "#fff")};
  }
`;

